import script from "./ExportPDF.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportPDF.vue?vue&type=script&lang=ts&setup=true"

import "./ExportPDF.vue?vue&type=style&index=0&id=15b57798&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b57798"]])

export default __exports__